import logo from "./Logo.png";
import Dictionary from "./Dictionary";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />{" "}
        </header>
        <main>
          <Dictionary />
        </main>
        <footer className="App-footer">
          Coded by{" "}
          <a
            href="https://github.com/AureliaMourey/dictionary-project"
            target="_blank"
            rel="noreferrer"
          >
            Aurelia Mourey
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/AureliaM-c/dictionary-project"
            target="_blank"
            rel="noreferrer"
          >
            open source on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://dictionary-project-ray.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
